module.exports = __webpack_public_path__ + "img/uc.b79b984b.jpg";